import { render, staticRenderFns } from "./HumanResourcesKPI.vue?vue&type=template&id=32f86d76&scoped=true"
import script from "./HumanResourcesKPI.vue?vue&type=script&lang=js"
export * from "./HumanResourcesKPI.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesKPI.vue?vue&type=style&index=0&id=32f86d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f86d76",
  null
  
)

export default component.exports